module.exports = {
    common: {
        "alert": "提示",
        "submit": "确认提交",
        "sure": "确认",
        "save": "保存",
        "ok": "确认",
        "cancel": "取消",
        "close": "关闭",
        "back": "返回",
        "result": "结果",
        "connotAccessed": "页面无法访问，请联系管理员!",
        "invalid": "页面已经失效，请重新扫描二维码登入!",
        "selectPackage": "请正确选择一个套餐",
        "increased": "人数只能往上增!",
        "moreNeed": '此桌子原先具有 {beginNum} 份, 现在增加{nowNum}份. 确定增加么?',
        "orderSuccess": "订单发送成功.",
        "orderstatechange": "订单状态已发生变化，请重新下单.",
        "orderSuccessfully": "下单成功!",
        "orderFailed": "下单失败!",
        "operationFailed": "操作失败!",
        "addSuccessfully": "新增成功!",
        "pageInvalid": "页面失效，请重新扫描二维码!",
        "deleteConfirm": "你确定删除此项么?",
        "confirm": "是否确定",
        "order":"下单",
        "submitOrder":"提交订单"
    },
    login: {
        "name": "姓名",
        "telephone": "电话",
        "begin": "开始",
        "number": "人数",
        "beginTime": "开始时间",
        "anonymous": "匿名登录",
        "nameNotNull": "请输入姓名.",
        "phoneNotNull": "请输入电话号码.",
        "accepetSendMsg":"允许接收短信",
    },
    buffetselect: {
        'title': "随便吃",
        "info":"如果您小于12周岁,您只需选择小孩套餐. 如果您大于12周岁，您需要选择成人套餐. 以下自助餐套餐字段应填写多少人",
        "next": "下一步",
        "successTip": " 您已成功订购自助餐套餐。请开始点自助餐。非常感谢。",
        "startBuffet": "开始自助餐",
        "more": "更多",
        "refresh": "刷新成功!",
        "moreNumber": "更多人数",
        "successfulOrderTip": "确认成功",
        "dear": "您好",
        "dinnerAsk":"请问多少人用餐?",
        "selectDinnerNum":"请选择用餐人数",
        "moreNumBtn":"更多",
        "tasteRequired":"您口味的需求",
        "startOrder": "开始点餐",
        "packageAlreadySelectedTip": "当前桌子已选套餐如下：",
        "selectedPackagesList": "{foodName}（{quantity}份）",
        "selectedPackagesListPlural": "{foodName}（{quantity}份）",
        "confirmContinueOrder": "确认进行点餐",
        "modifyPackageNum": "修改套餐人数",
    },
    unavailable: {
        "enterOrder": "进入点单",
        "contactRestaurant": "当前桌台尚未开台，请联系店家为您开台。",
        "closedHours": "当前为非营业时间，不能进行点单，请稍后再试。",
    },
    header: {
        "info":"信息",
        "opration":"操作",
        "cartList": "购物车列表",
        "cartListDsc": "您的购物车",
        "billList": "账单清单",
        "billListDsc": "已点订单",
        "modify": "添加",
        "modifyDsc": "添加人数",
        "artServices": "呼叫服务",
        "artServicesDsc": "呼叫服务人员",
        "confirmTips": "确认",
        "continueText": "请确认购物车的菜品后，再继续返回？",
        "humanText": "您需要呼叫服务人员吗？",
        "selectLanguage": "选择语言",
        "calledService": "您已经呼叫了服务，请稍等片刻!",
        "calledSuccessfully": "您已经成功呼叫了服务，请稍等服务人员给您服务!"
    },
    buffet: {
        "tip": "OBS！如果您吃完后桌上剩下4个以上的寿司/开胃菜，您将被收取每件15丹麦克朗的费用，加上您可以吃的所有价格。",
        "freePark": "免费区域",
        "payPark": "付费区域",
        "recommend": "推荐",
        "checklist": "核对列表",
        "reminder": "催单",
        "next": "下一步",
        "total": "总计",
        "share": "份数",
        "startOrder": "开始订单",
        "nullOrder": "您尚未提交订单，请选择要订购的菜肴！",
        "summary": "累计",
        "cartList": "购物车列表",
        "history": "历史",
        "served": "已服务",
        "nserved": "未服务",
        "description": "描述",
    },
    orderList: {
        "all": "全部",
        "total": "总计",
        "refresh": "刷新",
        "home": "继续点单",
        "return": "返回选择菜品",
        "info": "信息",
        "frist": "第1次点单",
        "second": "第2次点单",
        "third": "第3次点单",
        "fourth": "第4次点单",
        "moreth": '第{times}次点单',
        "morePeople": "更多人数",
        "buffetBatches": "套餐批次",
        "orderSubmitted": "正在提交订单，请稍候！",
        "submitCart": "您未选择菜品或者您的菜品已经被伙伴提交！",
        "sendKitchen": "发送给厨房",
        "remark": "备注",
        "choice": "选择",
        "with": "包括",
        "chooseWith": "选择您的",
        "selectOne": "选择一个",
        "oneOnlyOrder": "每人限点 {num} 份",
        "onePersonOrder": "每人限点 {num} 份",
         "maxEachTimeOrder":"每轮最多点 {num} 份 ",
        "timeLimit": "每次只能点{num}份.",
        "agreeWait": "您必须在下单之前同意出餐的等待时间.",
        "noDishes": "购物车未有菜品，请在下单前选择需要的菜品!",
        "submittedTips": "您的订单已提交或由其他合作伙伴提交。请不要再次提交.",
        "orderClosedTips": "订单已经关闭，请在此扫描二维码点餐，谢谢!",
        "reminderTips": "厨房收到了你的提醒。请等待5分钟后再发送！",
        "reminderSuccessfully": "催单成功！",
        "selectNumber": "您尚未选择人数，请选择人数并开始点餐！",
        "orderChangeTip": "订单状态变化",
        "deliveryType":"配送方式",
        "pickUp":"自取",
        "delivered":"送餐",
        "deliveryTypeNotNull":"请选择配送方式.",
        "dateNotNull":"请选择订单日期.",
        "timeNotNull":"请选择订单时间.",
        "orderDate":"订单日期",
        "orderTime":"订单时间",
        "name":"姓名",
        "telephone":"电话",
        "email":"邮件",
        "postNummer":"地区编码",
        "postBy":"地区名称",
        "address":"详细地址",
        "number":"人数",
        "adult":"成人",
        "children":"小孩",
        "specielle":"备注",
        "telephoneNotNull":"请输入电话号码",
        "nameNotNull":"请输入姓名",
        "emailNotNull":"请输入邮件",
        "numberNotNull":"请输入人数",
        "postNummerNotNull":"请输入配送地区编码",
        "postByNotNull":"请输入配送地区名字",
        "addressNotNull":"请输入配送地址",
        "customerInfo":"订单信息",
        "methodAndTime":"配送方式和时间",
        "orderNo":"取餐码",
        "deliveryFee":"送餐费用",
        "orderNotNull":"你未点对应菜品，请返回先点餐.",
        "orderList":"我的订单列表",
        "subAmount":"小计",
        "postAmount":"送餐费",
        "emailError":"请输入正确的邮箱格式",
        "confirmOrder":"确认订单",
        "limitTimeTitle":"超时提醒",
        "limitTimeTips":"您用餐时间已经超过设定的用餐时间，请联系店内人员进行服务，非常感谢您的关顾！",
        "chargedOnceTips":"此菜品仅收第一份费用，后续加点免费",
         "foodMaxEachTimeOrder":"菜品{foodName}每次只能点{num}份，请调整后再提交，感谢!",
         "orderingTip":"此桌子在下单中，请稍微再试!",
         "personNum":"用餐人数",
         "maxiNum":"每次只能点(份)",
         "upperLimit":"总上限(份)",
         "selectedList":"已选列表",
         "clickToSelect":"请点击选择上面",
         "delete":"删除",
         "units":"份数",
         "who":"归属人（可选）",
         "nullRemark":"谁点的",
         "needMax1":"份数不能小于1",
          "upperMaxLimit":"超出总上限！最多还能点(份):",
          "oneLimit":"{user}最多点{maxPerPerson}份，已点{userUsed}份"
        },
    result: {
        tips: "订单已完成，重新点单请重新扫描二维码。",
        closePage: "关闭页面",
        errorTips: "访问页面缺失，请再次扫描二维码以点单。"
    }
}


// WEBPACK FOOTER //
// ./src/assets/i18n/cn.js